import { targetValidation } from '../../../../const/targetValidation';
import Yup from '../../../../vendor/yup';



export const makeValidationSchema = (dynamicData = {}) => Yup.object().shape({
  title: Yup.string()
    .min(3, 'Min 3 symbols required')
    .max(255, 'Max 255 symbols required')
    .required('Required to specify title'),
  client_id: Yup.number()
    .positive('Value must be a positive number')
    .required('Required to specify App Id')
    .typeError('Value must be a number'),
  template_id: Yup.string().required('Required to specify template'),
  is_published: Yup.bool().default(false),
  description: Yup.string()
    .min(50, 'Min 50 symbols required')
    .max(5000, 'Max 5000 symbols required')
    .required('Required to specify description'),
  options: Yup.string()
    .max(5000, 'Max 5000 symbols required')
    .nullable()
    .test('is-json', 'Must be a valid JSON string', (value) => {
      if (!value) return true;
      try {
        JSON.parse(value);
        return true;
        // eslint-disable-next-line no-unused-vars
      } catch (error) {
        return false;
      }
    }),
  target: targetValidation,
  ...dynamicData,
});
